import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs';
import TitleOutputLeftSide from '../../components/title/TitleOutputLeftSide';
import TitleOutputRightSide from '../../components/title/TitleOutputRightSide';
import DownloadIcon from '@mui/icons-material/Download';
import { useDispatch, useSelector } from 'react-redux';
import { selectTitleCheckResponse, selectTitlePdfLoading } from '../../redux-state/selectors';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import SecondaryButton from '../../components/common/button/SecondaryButton';
import { DOWNLOAD_TITLE_OUTPUT } from '../../redux-state/types';

export default function TitleOutput() {
  const navigate = useNavigate();
  const titleResponse = useSelector(selectTitleCheckResponse);
  const loadingState = useSelector(selectTitlePdfLoading);
  const dispatch = useDispatch();

  const convertToPdf = () => {
    dispatch({
      type: DOWNLOAD_TITLE_OUTPUT,
    });
  };

  return (
    <div className='p-4 lg:p-8 min-h-[900px]'>
      <div className='flex flex-row justify-between'>
        <div className='mb-4'>
          <CustomBreadcrumbs title={"Lien & Title Check"} subtitle={"Lien & Title Check Output"}/>
        </div>
        <div>
          <SecondaryButton
            text="Back"
            onClick={() => navigate(-1)}
          />
        </div>
      </div>

      <div className='text-3xl font-bold text-gray-900 mb-2'> Lien & Title Check Output </div>
      <div className='text-gray-600 mb-6'> {titleResponse["Transaction ID"]} </div>
      <div className="w-full flex justify-end mb-8">
        <PrimaryButton
          text={
            <>
              <DownloadIcon sx={{ mr: '6px' }} />
              Download
              {loadingState && (
                <span className="ml-4 animate-spin inline-block w-4 h-4 border-2 border-t-transparent border-white rounded-full mr-2" />
              )}
            </>}
          className={`custom-download-button`}
          disabled={loadingState}
          onClick={convertToPdf}
        />
      </div>

      <div className='flex flex-col xl:flex-row w-full gap-6'>
        <div className='w-full xl:w-1/2 min-w-0'>
          <TitleOutputLeftSide />
        </div>

        <div className="hidden xl:block w-px bg-gray-300" />

        <div className='w-full xl:w-1/2 min-w-0 xl:mt-16'>
          <TitleOutputRightSide />
        </div>
      </div>
    </div>
  )
}